import { useCallback } from 'react'

import { TOAST_STATUSES } from '@/components/toast/Toast.jsx'

import useAlert from './useAlert.jsx'

/**
 * Usage:
 *
 * const showError = useError()
 * showError('something wrong')
 *
 * */

const useError = () => {
    const { triggerAlert } = useAlert()

    return useCallback(errorMessage => {
        triggerAlert({ variant: TOAST_STATUSES.FAILURE, message: errorMessage })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
}

export default useError
